<template>
  <div
    class="subscribe-ab-guid-box"
    :class="{
      [`subscribe-ab-guid-box--${createRenderType}`]: true,
    }"
  >
    <div
      class="subscribe-ab-guid-content"
      :style="{
        background: renderData.data.background,
        backgroundSize: 'cover',
        '--titleColorMask': renderData.data.titleColorMask,
        '--descColorMask': renderData.data.descColorMask,
      }"
    >
      <div class="subscribe-ab-guid-img">
        <img :src="renderData.data.img" />
      </div>
      <div class="subscribe-ab-guid-content-box">
        <!-- <div class="subscribe-ab-guid-title olh">
          {{ renderData.data.title }}
        </div> -->
        <div class="subscribe-ab-guid-desc omlh-2">
          {{ renderData.data.desc }}
        </div>
        <div class="subscribe-ab-guid-btn">
          <Button
            @click="goSubscribe"
            :renderStyle="{
              '--padding': '0 16px',
              '--width': 'max-content',
              '--height': createRenderType == 'mobile' ? '30px' : '36px',
              '--borderRadius': '48px',
              '--background': 'rgba(0, 0, 0, 1)',
              '--fontColor': '#FFFFFF',
              '--fontSize': createRenderType == 'mobile' ? '12px' : '14px',
              '--fontWeight': 'normal',
              '--border': 'none',
              '--backgroundHover': 'rgba(0, 0, 0, 0.75)',
              '--fontColorHover': '#FFFFFF',
            }"
          >
            {{ renderData.data.btn }}
          </Button>
        </div>
      </div>
      <div class="subscribe-ab-close-btn">
        <IconButton
          v-if="renderData.linkurl != ''"
          :size="createRenderType == 'mobile' ? '30px' : '36px'"
          :icoSize="createRenderType == 'mobile' ? '16px' : '20px'"
          backgroundColor="rgb(0, 0, 0, 0)"
          hoverBackgroundColor="rgb(0, 0, 0, 0.1)"
          @onClick="close"
        >
          <img src="@/assets/img/ab/close-ico-black-3x.png" />
        </IconButton>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
  getCurrentInstance,
} from "vue"
import { storeToRefs } from "pinia"

import Button from "@/components/basic/button/Button.vue"
import IconButton from "@/components/basic/button/IconButton.vue"

import shapeMelodyImg from "@/assets/img/ab/shape-melody.png"
import vocalVoiceImg from "@/assets/img/ab/vocal-voice.png"
import downloadStemImg from "@/assets/img/ab/download-stem.png"
import generateSimilarSongImg from "@/assets/img/ab/generate-similar-song.png"

import useCreateLayoutStore from "@/store/create/createLayoutStore.js"
import useUserDataStore from "@/store/userDataStore"
import useFeedListStore from "@/store/create/feedListDataStore.js"

const userDataStore = useUserDataStore()
const createLayoutStore = useCreateLayoutStore()
const feedListDataStore = useFeedListStore()

const { createRenderType } = storeToRefs(createLayoutStore)

const { $$language, $$t, $$tm, $$tValue } = getCurrentInstance().appContext?.config.globalProperties.$i18n ?? {}

const props = defineProps({
  type: {
    type: String,
    default: "download_stem", // vocal_voice shape_melody download_stem generate_similar_song
  },
})
const emits = defineEmits([])
const styleMap = {
  vocal_voice: {
    background: "linear-gradient(101deg, #E894FF 0%, #9EFCFF 100%)",
    img: vocalVoiceImg,
    titleColorMask:
      "linear-gradient(93deg, #560E66 0%, #5B43E2 99%, #432DBB 99%)",
    descColorMask: "linear-gradient(95deg, #560E66 0%, #432DBB 100%)",
  },
  download_stem: {
    background: "linear-gradient(101deg, #FFB7FB 0%, #FF93E2 100%)",
    img: downloadStemImg,
    titleColorMask:
      "linear-gradient(94deg, #370934 0%, #8A129F 100%, #432DBB 100%)",
    descColorMask:
      "linear-gradient(94deg, #370934 0%, #8A129F 100%, #432DBB 100%)",
  },
  generate_similar_song: {
    background:
      "linear-gradient(101deg, #B2E7FF 0%, #D1D3FF 48%, #82CBFF 100%)",
    img: generateSimilarSongImg,
    titleColorMask:
      "linear-gradient(90deg, #1F2E61 0%, #463ED4 107%, #432DBB 107%)",
    descColorMask:
      "linear-gradient(90deg, #1F2E61 0%, #463ED4 107%, #432DBB 107%)",
  },
  shape_melody: {
    background:
      "linear-gradient(101deg, #FF6FEC 0%, #FFCDFB 50%, #FAE5FF 100%)",
    img: shapeMelodyImg,
    titleColorMask:
      "linear-gradient(94deg, #370934 0%, #8A129F 100%, #432DBB 100%)",
    descColorMask:
      "linear-gradient(94deg, #370934 0%, #8A129F 100%, #432DBB 100%)",
  },
}

const membershipSourceType = {
  vocal_voice: "vocal_local",
  download_stem: "download_stem",
  generate_similar_song: "generate_similar_song",
  shape_melody: "melody_ideas",
}

const getRenderData = () => {
  const textMap = {
    vocal_voice: {
      desc: $$t("editor.create_subscribe_type_vocal_voice_desc"),
      btn: $$t("editor.upgrade_to_pro"),
    },
    download_stem: {
      desc: $$t("editor.create_subscribe_type_download_stem_desc"),
      btn: $$t("editor.upgrade_to_pro"),
    },
    generate_similar_song: {
      desc: $$t("editor.create_subscribe_type_generate_similar_song_desc"),
      btn: $$t("editor.upgrade_to_pro"),
    },
    shape_melody: {
      desc: $$t("editor.create_subscribe_type_shape_melody_desc"),
      btn: $$t("editor.upgrade_to_pro"),
    },
  }
  return {
    ...textMap[props.type],
    ...styleMap[props.type],
  }
}
const renderData = reactive({
  data: getRenderData(),
})

const goSubscribe = () => {
  const globalProperties = (
    getCurrentInstance() || window?.$getVueCurrentInstance?.()
  )?.appContext?.config?.globalProperties
  const Router = (getCurrentInstance() || window?.$getVueCurrentInstance?.())
    .appContext?.config?.globalProperties?.$router
  Router.push({
    name: "subscribe",
    query: {
      membership_source1: "ad_source",
      membership_source2: props.type,
    },
  })

  globalProperties.logClickEvent("create_generated_zone_subscribe_ads", {
    source: props.type,
  })
}

const close = () => {
  const globalProperties = (
    getCurrentInstance() || window?.$getVueCurrentInstance?.()
  ).appContext?.config?.globalProperties
  createLayoutStore.setFeedSubscribeIsRender(false)
  globalProperties?.logClickEvent("create_generated_zone_subscribe_ads_close", {
    type: userDataStore.isLogin ? "sign_in" : "not_sign_in",
  })
}

onMounted(() => {})
</script>
<style lang="scss">
.subscribe-ab-guid-box {
  height: 128px;
  border-radius: 16px;
  overflow: hidden;
  position: relative;

  margin: 6px 20px 8px 20px;

  .subscribe-ab-guid-content {
    height: 100%;
  }
  .subscribe-ab-guid-content-box {
    height: 100%;
  }
  .subscribe-ab-guid-img {
    height: 100%;
    display: flex;
    justify-content: end;
    align-items: center;
    img {
      height: 100%;
    }
  }
  .subscribe-ab-guid-content-box {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 17px 40px 17px 18px;
  }
  .subscribe-ab-guid-title {
    font-family: HarmonyOS Sans SC;
    font-size: 22px;
    font-weight: bold;
    line-height: 24px;
    background: var(--titleColorMask);
    background-clip: text;
    color: transparent;
  }
  .subscribe-ab-guid-desc {
    font-family: HarmonyOS Sans SC;
    font-size: 18px;
    line-height: 24px;
    // font-weight: 600;
    background: var(--descColorMask);
    background-clip: text;
    color: transparent;
    min-height: 48px;
    padding-right: 230px;
    max-width: 600px;
  }
  .subscribe-ab-guid-btn {
    margin: 9px 0 0 0;
    display: flex;
    justify-content: start;
    align-items: center;
  }
  .subscribe-ab-close-btn {
    position: absolute;
    top: 10px;
    right: 10px;
  }
  &.subscribe-ab-guid-box--mobile {
    margin: 3px 18px 8px 18px;
    border-radius: 16px;
    height: 100px;
    .subscribe-ab-guid-content-box {
      padding: 14px 40px 14px 14px;
    }
    .subscribe-ab-guid-img {
      img {
        margin-right: -30px;
      }
    }
    .subscribe-ab-guid-desc {
      min-width: 500px;
      padding-right: 230px;
      font-size: 12px;
      line-height: 18px;
      min-height: 36px;
      max-width: 500px;
    }
    .subscribe-ab-guid-btn {
      margin: 6px 0 0 0;
    }
    .subscribe-ab-close-btn {
      top: 8px;
      right: 6px;
    }
  }
}
</style>
